export default "__VITE_ASSET__f46MGuDZ__"